import { FC } from 'react';
import cn from 'classnames';
import styles from './OrganizationTextBlockOrganism.module.css';
import { Button, Textarea, ValidationForm } from '../../atoms';
import { RichTextBlockResponseDto } from '../../../store/buyerAPI/block/dto/response/rich-text-block-response.dto';

interface OrganizationTextBlockOrganismProps {
  handleOnChange: (textBlock: RichTextBlockResponseDto) => void;
  textBlock: RichTextBlockResponseDto;
  callbackFn: (textBlock: RichTextBlockResponseDto) => void;
}

const OrganizationTextBlockOrganism: FC<OrganizationTextBlockOrganismProps> = ({
  handleOnChange,
  textBlock,
  callbackFn,
}) => {
  return (
    <div className={cn(styles.textBlockWrapper)}>
      <ValidationForm onSubmitCallback={() => callbackFn(textBlock)}>
        <Textarea
          content={textBlock.content ?? ''}
          setContent={(e) => handleOnChange({ ...textBlock, content: e })}
        />
        <div className={cn(styles.button)}>
          <Button variant="dark" type="submit">
            Save
          </Button>
        </div>
      </ValidationForm>
    </div>
  );
};

export default OrganizationTextBlockOrganism;
